import { execute } from '@/api/execute'
import { GET, PUT, POST, DELETE } from '@/api/types'
import { addQueryParams } from '@/util/index.js'
import store from '@/store'

const ENDPOINT = 'manager/ingtedienttypes'

export default {
  list (params = {}) {
    return execute(GET, addQueryParams(`${ENDPOINT}/`, params))
  },

  default (params = {}) {
    const language = store.getters['account/lang'] || 'uk'

    const defaultParams = {
      language,
      ...params
    }

    return execute(GET, addQueryParams('manager/ingredienttypes/default/', defaultParams))
  },

  litelist (params = {}) {
    return execute(GET, addQueryParams(`${ENDPOINT}/list/`, params))
  },

  create (payload) {
    return execute(POST, `${ENDPOINT}/`, payload)
  },

  getById (id) {
    return execute(GET, `${ENDPOINT}/${id}/`)
  },

  updateById (id, payload) {
    return execute(PUT, `${ENDPOINT}/${id}/`, payload)
  },

  deleteById (id) {
    return execute(DELETE, `${ENDPOINT}/${id}/`)
  }
}
